import i18n from 'live/services/i18n'

export const type = 'product-kpi-plugin-rig-floor:widget'
export const name = i18n('[KPI] Rig Floor Editing Tool')
export const description = i18n('Rig Floor Editing Tool')

export const riserType = 'product-kpi-plugin-rig-floor:riser-widget'
export const riserName = i18n('[KPI] Riser Editing Tool')
export const riserDescription = i18n('Riser Editing Tool')

export const kpisLimit = 100

export const TRIPPING_IN_KPIS = [
    'IN_SLIPS_TO_RACKER_RELEASE_TIME',
    'RACKER_RELEASE_TO_SPIN_IN_START_TIME',
    'SPIN_IN_START_TO_END_TIME',
    'SPIN_IN_END_TO_MAKE_UP_START_TIME',
    'MAKE_UP_START_TO_END_TIME',
    'MAKE_UP_END_TO_IR_MOVE_OUT_TIME',
    'IR_MOVE_OUT_TO_OFF_SLIPS_TIME'
]

export const TRIPPING_OUT_KPIS = [
    'IN_SLIPS_TO_BREAK_OUT_START_TIME',
    'BREAK_OUT_START_TO_END_TIME',
    'BREAK_OUT_END_TO_SPIN_OUT_START_TIME',
    'SPIN_OUT_START_TO_END_TIME',
    'SPIN_OUT_END_TO_HR_GRIPPER_CLOSED_TIME',
    'HR_GRIPPER_CLOSED_TO_TD_ELEV_CLOSED_TIME',
    'TD_ELEV_CLOSED_TO_OFF_SLIPS_TIME'
]

// Rótulos exibidos em vez do formato literal do mnemônico (OGP21-5137: mnemônico
// permanece HR_GRIPPER_CLOSED por compatibilidade, só o texto exibido muda para HR Hold Pipe).
const KPI_LABEL_OVERRIDES: Record<string, string> = {
    SPIN_OUT_END_TO_HR_GRIPPER_CLOSED_TIME: 'Spin Out End To Hr Hold Pipe Time',
    HR_GRIPPER_CLOSED_TO_TD_ELEV_CLOSED_TIME: 'Hr Hold Pipe To Td Elev Closed Time',
    // Riser KPIs: "Definition" names from "Riser KPIs Definition & Heuristics — V2" (Confluence 5835522071)
    IN_RISER_SPIDER_TO_RRT_RELEASE_TIME: 'In Riser Spider to RRT Release',
    RRT_RELEASE_TO_CATWALK_AT_WELL_CENTER_TIME: 'RRT Release to Catwalk at Well Center',
    CATWALK_AT_WC_TO_RRT_ENGAGE_TIME: 'Catwalk at Well Center to RRT Engage',
    RRT_ENGAGE_TO_JOINT_LIFT_OFF_TIME: 'RRT Engage to Joint Lift-Off',
    JOINT_LIFT_OFF_TO_STAB_IN_TIME: 'Joint Lift-Off to Stab-In',
    STAB_IN_TO_OUT_OF_RISER_SPIDER_TIME: 'Stab-in to Out of Riser Spider',
    IN_RISER_SPIDER_TO_CATWALK_AT_WC_TIME: 'In Riser Spider to Catwalk-at-WC',
    CATWALK_AT_WC_TO_JOINT_LIFT_OFF_TIME: 'Catwalk-at-WC to Joint Lift-Off',
    JOINT_LIFT_OFF_TO_JOINT_SET_DOWN_TIME: 'Joint Lift-Off to Joint Set-Down',
    JOINT_SET_DOWN_TO_RRT_RELEASE_TIME: 'Joint Set-Down to RRT Release',
    RRT_RELEASE_TO_RRT_REENGAGE_TIME: 'RRT Release to RRT Re-engage',
    RRT_REENGAGE_TO_OUT_OF_RISER_SPIDER_TIME: 'RRT Re-engage to Out of Riser Spider'
}

const formatKpiOption = (value: string) => ({
    value,
    label:
        KPI_LABEL_OVERRIDES[value] ??
        value
            .toLowerCase()
            .replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase())
})

export const KPI_OPTIONS = [...TRIPPING_IN_KPIS.map(formatKpiOption), ...TRIPPING_OUT_KPIS.map(formatKpiOption)]

// Riser Run (Riser Editing Tool, Trip In side). Mnemonics match IndicatorRigFloor.java exactly.
export const RISER_RUN_KPIS = [
    'IN_RISER_SPIDER_TO_RRT_RELEASE_TIME',
    'RRT_RELEASE_TO_CATWALK_AT_WELL_CENTER_TIME',
    'CATWALK_AT_WC_TO_RRT_ENGAGE_TIME',
    'RRT_ENGAGE_TO_JOINT_LIFT_OFF_TIME',
    'JOINT_LIFT_OFF_TO_STAB_IN_TIME',
    'STAB_IN_TO_OUT_OF_RISER_SPIDER_TIME'
]

// Riser Pull (Riser Editing Tool, Trip Out side). Mnemonics match IndicatorRigFloor.java exactly
// (added OGP21-5145, commit 65009eb5 - previously backlog, now implemented).
export const RISER_PULL_KPIS = [
    'IN_RISER_SPIDER_TO_CATWALK_AT_WC_TIME',
    'CATWALK_AT_WC_TO_JOINT_LIFT_OFF_TIME',
    'JOINT_LIFT_OFF_TO_JOINT_SET_DOWN_TIME',
    'JOINT_SET_DOWN_TO_RRT_RELEASE_TIME',
    'RRT_RELEASE_TO_RRT_REENGAGE_TIME',
    'RRT_REENGAGE_TO_OUT_OF_RISER_SPIDER_TIME'
]

export const RISER_KPI_OPTIONS = [...RISER_RUN_KPIS.map(formatKpiOption), ...RISER_PULL_KPIS.map(formatKpiOption)]
